import React from 'react';
import { Button, Card } from 'semantic-ui-react';
import { getPath } from '../../../helpers/utils';
import { useSelector } from 'react-redux';
import MultiLineChart from '../../common/charts/MultiLineChart';
import { KPI_MAP } from '../../../helpers/dashboardUtil';

export const KPI_WIDGET_MAP = {
    // New Widgets
    AWS_OUTPOST_INSTANCE_CAPACITY: 'Widget8_AwsOutputInstanceFamilyCapacityUtilization',
    AWS_EC2_CPU_UTILIZATION: 'Widget9_AwsEc2CpuUtilization',
    AWS_S3_BUCKET_SIZE_BYTES: 'Widget7_AwsS3BucketSizeBytes',
    AWS_OUTPOST_CONNECTED_STATUS: 'Widget6_ConnectedStatus',
    AWS_S3_NUMBER_OF_OBJECTS: 'Widget1_S3NumberOfObjectAverage',
    AWS_EBS_VOL_READ_BYTES: 'Widget2_AwsEbsVolumeReadBytes',
    AWS_EBS_VOL_WRITE_BYTES: 'Widget4_AwsEbsVolumeWriteBytes',
    AWS_EC2_NETWORK_IN: 'Widget3_AwsEc2NetworkIn',
    AWS_EC2_NETWORK_OUT: 'Widget5_AwsEc2NetworkOut'
};

export const AWSKPIWidget = (props) => {
    const { history, title, data, kpi, isOSNDMECAllowed, DEFAULT_REGION } = props;
    const { enterpriseId } = useSelector((state) => state.auth);

    return (
        <>
            <Card.Content className="AWS-card">
                <Card.Header textAlign="left">
                    {title?.split('/').map((part, index) => (index !== 0 ? <span style={{ fontWeight: 'normal' }}>{'/' + part}</span> : part))}
                    {data && (
                        <div className="right-aligned-part">
                            <span>{DEFAULT_REGION}</span>
                            <Button
                                size="small"
                                floated="right"
                                secondary
                                onClick={() => {
                                    history.push(getPath(enterpriseId, `/mec/performance${isOSNDMECAllowed ? `-osnd` : ``}`), {
                                        key: KPI_MAP[kpi]?.key
                                    });
                                }}>
                                View more
                            </Button>
                        </div>
                    )}
                </Card.Header>
                <Card.Description textAlign="left">
                    {KPI_WIDGET_MAP[kpi] && data ? (
                        isOSNDMECAllowed ? (
                            <MultiLineChart
                                config={{
                                    height: 320,
                                    isDashboardWidget: true,
                                    xAxisTitle: 'Time',
                                    titleStyle: {
                                        color: 'black',
                                        fontWeight: 'bold'
                                    },
                                    ...data
                                }}
                                type={'spline'}
                            />
                        ) : (
                            <tsm-mfe-mec-dashboard height="330px" widget-id={KPI_WIDGET_MAP[kpi]} />
                        )
                    ) : (
                        <div className="no-data-placeholder">No data available.</div>
                    )}
                </Card.Description>
            </Card.Content>
        </>
    );
};
